<template src="./index.html"></template>
<style lang="scss" scoped src="./index.scss"></style>
<script>
import { Toast, Popup, Field } from 'vant';
export default {
  name: "LabelPage",
  components: { Popup, Field },
  data() {
    return {
      one_level: [],
      two_level: [],
      three_level: [],
      SelectLabelItemActive: {},
      ItemAddPopup: false,
      ItemDeletePopup: false,
      addRvisit: [{value:''}], //添加回访次数标签
      addRvisitIndex: 0,
      rVisitNum: '', //自定义回访次数
      i_index: "",
      rVisitInput: false,
    };
  },
  mounted() {
    this.getTag(); 
  },
  methods: {
    getTag(num) {
      if(this.$route.params.LabelParams){
        this.SelectLabelItemActive = JSON.parse(JSON.stringify(this.$route.params.LabelParams))
      }
      this.$store.dispatch("AddressBook/GetAddressBook", {}).then((res) => {
        if (res.code == 1000) {
          this.one_level = res.data.one_level;
          this.two_level = res.data.two_level;
          this.three_level = res.data.three_level;
          if(num == 1) {
            Toast('保存成功')
          }
        }
      });
    },
    ItemAdd(){
      this.ItemAddPopup = true
    },
    
    // 选择标签
    SelectLabelItem(item, index) {
      if (this.SelectLabelItemActive[item.key] == index) {
        delete this.SelectLabelItemActive[item.key];
      } else {
        this.SelectLabelItemActive[item.key] = index;
      }
      if(item.label == '回访次数') {
        this.rVisitNum = ''
        this.rVisitInput = false
      }
      this.$forceUpdate();
    },
    // 判断子标签样式
    LabelItemClass(key) {
      const ClattMap = ["ItemOne", "ItemTwo", "ItemThree"];
      const KeyMap = [
        ["order_type", "custom_type", "member_type", "customized"],
        ["custom_level", "recall_num", "expired_date"],
        ["custom_order_fee", "pay_cycle"],
      ];
      let ClassName = null;
      KeyMap.map((n, i) => {
        if (n.includes(key)) {
          ClassName = ClattMap[i];
        }
      });
      return ClassName;
    },
    SaveButton() {
        Toast("筛选成功")
        if(this.rVisitNum !== '') {
          this.SelectLabelItemActive.rVisitNum = this.rVisitNum
        }else {
          this.SelectLabelItemActive.rVisitNum = ''
        }
        setTimeout(()=>{
          this.$router.push({name:'AddressBook', params: {LabelParams:this.SelectLabelItemActive} })
        },2000)
    },
    addRvisitChange(e) {
      // this.addRvisit[this.addRvisitIndex].value = e.replace(/\s+/g,'')
      this.addRvisit[this.addRvisitIndex].value = e.replace(/[^\u4E00-\u9FA5|\d|\a-zA-Z|\r\n\s,.?!，《<>》。？！…—&$=()-+/*{}[\]]|\s/g, '')
      this.$forceUpdate()
    },
    addRvisitFocus(index) {
      this.addRvisitIndex = index
    },
    addMore() {
      this.addRvisit.push({value:''})
    },
    rVisitNumChange(v) {
      // if(v == 0) {
      //   v = ''
      // }
      // this.rVisitNum = v
      // console.log(v)
    },
    showInput() {
      delete this.SelectLabelItemActive["recall_num"]
      this.rVisitInput = true
    },
    saveTag() {
      let saveType = true
      for(let i in this.addRvisit) {
        if(this.addRvisit[i].value == '') {
          saveType = false
        }
      }
      if(!saveType) {
        Toast('请输入完整的标签内容')
      }else {
        var ary = [];
        let str = ''
        let inputType = true
        for(let i in this.addRvisit) {
          ary.push(this.addRvisit[i].value)
          if(i < this.addRvisit.length-1) {
            str += this.addRvisit[i].value+','
          }else {
            str += this.addRvisit[i].value
          }
        }
        var nary = ary.sort();
        for(var i = 0; i < nary.length - 1; i++) {
          if(nary[i] == nary[i + 1]) {
            inputType = false
          }
        }
        if(inputType) {
          let obj = {
            source: 2,
            label_text: this.addRvisit,
          }
          this.$store.dispatch("AddressBook/addCustomLabel", obj).then((res) => {
            if(res.code == 1000) {
              this.ItemAddPopup = false
              this.addRvisit = [{value:''}]
              this.getTag(1); 
            }
          });
        }else {
          Toast('标签名有重复哦')
        }
        
      }
    },
    closeItemAddPopup() {
      this.ItemAddPopup = false
      this.addRvisit = [{value:''}]
    },
    deleteTag( i_index) {
      this.i_index = i_index
      this.ItemDeletePopup = true
    },
    noDele() {
      this.ItemDeletePopup = false
    },
    clickDeleBtn() {
      let list = []
      for(let i in this.two_level) {
        if(this.two_level[i].label=="自定义标签") {
          list = this.two_level[i].data
        }
      }
      let obj = {
        source: 2,
        sign_id: list[this.i_index].label_value,
      }
      
      this.$store.dispatch("AddressBook/delCustomLabel", obj).then((res) => {
        if(res.code == 1000) {
          Toast('删除成功')
          for(let i in this.two_level) {
            if(this.two_level[i].label=="自定义标签") {
              this.two_level[i].data.splice(this.i_index, 1)
            }
          }
          this.ItemDeletePopup = false
        }
      });

    },
  },

  beforeDestroy() {
    this.$store.commit('AddressBook/offset_set', 0)
    this.$store.commit("AddressBook/SET_DATA", {
      key: "getTableData",
      data: [],
    });
    this.$store.commit("AddressBook/SET_DATA", {
      key: "starMarkList",
      data: [],
    });
    this.$store.commit("AddressBook/SET_DATA", {
      key: "noStarMarkList",
      data: [],
    });
  }
};
</script>